import * as yup from "yup";

export type FlashSaleValidationType = yup.InferType<typeof FlashSaleValidation>;

export const FlashSaleValidation = yup.object().shape({
	lastMinuteDiscount: yup.number().min(10, "Can't be lower than 10").max(100, "").typeError(""),
	flashSaleEnable: yup.boolean(),
});
